import { SPRACHEN, t } from './sprache'
import { de } from './sprache/de'
import { en } from './sprache/en'

/**
 * Die Sprache in der Fußzeile.
 *
 * Eine bewusste Ausnahme von 7.2: Der waagerechte Streifen trägt den
 * **fachlichen** Kontext — Kreis, Rechnungslegung, Periode. Die Sprache ist
 * eine Anzeigeeinstellung und gehört dem Buchstaben nach unter *Betrieb*.
 *
 * Sie steht trotzdem hier, aus einem Grund, der aus der Praxis kommt: Wer
 * eine Kundendatenbank betreut und seinen Bildschirm abwechselnd deutschen und
 * englischen Anwendern zeigt — in einer Schulung etwa —, schaltet mitten im
 * Gespräch um. Ein Umweg über einen Verwaltungsbildschirm bedeutet, den
 * gezeigten Bildschirm zu verlassen und die Vorführung zu unterbrechen.
 *
 * **Die Zahlendarstellung stand bis zum 2026-10-06 daneben** und steht jetzt
 * im Profil (7.2 Abschnitt 43, R1314): Sie fasst man ein-, zweimal im Jahr
 * an, und unter *Anwender und Rechte* beantwortete sie keine Frage.
 */

const SPRACHNAMEN: Record<string, string> = {
  de: de['sprache.name'],
  en: en['sprache.name'],
}

export function Schnellzugriff({
  sprache,
  aufSprache,
}: {
  sprache: string
  aufSprache: (code: string) => void
}) {
  return (
    <div className="schnellzugriff">
      <div className="feld">
        <label htmlFor="schnell-sprache">{t('kopf.sprache')}</label>
        <select
          id="schnell-sprache"
          value={sprache}
          onChange={(e) => aufSprache(e.target.value)}
        >
          {SPRACHEN.map((code) => (
            <option key={code} value={code}>
              {SPRACHNAMEN[code] ?? code}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
